// extracted by mini-css-extract-plugin
export default {"root":"CreateCampaign_root__RjJ7n","tabs":"CreateCampaign_tabs__r4m3z","tab":"CreateCampaign_tab__3KCgs"};